
import {AccountsView} from "../views/AccountsView.tsx";
import { DomainLayout } from "@/components/layouts/DomainLayout";

export const AccountsPage = () => {
    return (
        <DomainLayout>
            <AccountsView />
        </DomainLayout>
    )
}